<template>
    <div class="page naw">
        <h2>Laat je gegevens achter om kans te&nbsp;maken</h2>
        <v-form class="v-form"></v-form>
    </div>
</template>

<style lang="scss" scoped>
    .v-form{
        max-width:500px;
        margin:0 auto;
    }
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Form from '@/app/components/Form';

    export default {
        components: {
            'v-form': Form
        },

        computed:
        {
            correct()
            {
                return this.$store.getters.correct;
            }
        },

        mounted()
        {
            this.$store.dispatch( 'sky', 'darker' );
            this.$store.dispatch( 'sun', 'up' );
        },

        methods:
        {
            getAnimateIn()
            {
                let tl = new TimelineMax({ delay: 0.5 });

                tl.staggerFrom( '.page.naw > *', 0.5, { y: -50, opacity: 0 }, 0.05 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( '.page.naw', 0.3, { y: -50, opacity: 0 });

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Naw.vue